import '../../app.es6';
import angular from 'angular';

class PasswordForgetController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location, $window,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$location = $location;
    this.$window = $window;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    this.isLoginFailed = false;      // サインインチェック
    this.isPleaseInput = false;      // 必須入力
    this.sendOk = false;

    Page.setTitle(this.Const.TITLE.passForget);

    PasswordForgetController.$inject = [
      '$scope', '$sessionStorage', '$location',
      '$window', 'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  submit () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    if (!this.userId || !this.mail) {
      this.switchErrorMessage(this.Const.ERROR_TYPE.pleaseInput);
      this.commonFactory.overlayHidden();
      return;
    }
    this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
    let MembersMePasswordReset = {
      companyCode: 'RNSS',
      displayId: this.userId,
      email: this.mail
    };
    this.commonApiFactory.postMembersPasswordReset(MembersMePasswordReset)
    .then((result) => {
      this.isLoginFailed = false;      // サインインチェック
      this.isPleaseInput = false;      // 必須入力
      this.sendOk = !this.sendOk;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  cancel () {
    this.$location.path('/member/login');
  }

  switchErrorMessage (errorType) {
    switch (errorType) {
      case this.Const.ERROR_TYPE.loginFailed:
        this.changeErrorMessage(true, false);
        break;
      case this.Const.ERROR_TYPE.pleaseInput:
        this.changeErrorMessage(false, true);
        break;
      case this.Const.ERROR_TYPE.clear:
        this.changeErrorMessage(false, false);
        break;
      default:
        this.changeErrorMessage(false, false);
    }
  }

  changeErrorMessage (loginFailedFlag, pleaseInput) {
    this.isLoginFailed = loginFailedFlag;
    this.isPleaseInput = pleaseInput;
  }

  back () {
    this.$window.history.back();
  }
}

angular.module('myApp')
  .controller('PasswordForgetController', PasswordForgetController);



// WEBPACK FOOTER //
// ./app/components/password-forget/password-forget-controller.es6